
import { Component, Vue, Watch } from "vue-property-decorator";
import axios from "axios";

@Component({
  components: {},
})
class Home extends Vue {
  additivefiltering = false;
  clientMain = "81a9f355-1b78-41b1-b290-208dc98d85b7";
  clientFunds = "1db4caae-6687-429d-bfd3-34fb41c86160";
  clientManagement = "9b59fcfc-9efe-48f7-b734-3ea5e7f24ca3";
  gridView = false;
  loading = false;
  workingTimes = [];
  jobs: any[] = [];
  jobsFiltered: any[] = [];
  customGroupedJobs: Record<string, any[]> = {};
  jobcategories: any[] = [];
  locations: any[] = [];
  audiences: any[] = [];
  worktimes: any[] = [];
  filterPanels: Array<{
    uid: number;
    title: string;
    catalogType: string;
    options: Record<string, string>;
  }> = [];

  beforeMount() {
    if (this.$route.query.id) {
      console.log(this.$route.query.id);
      this.$router.push({
        name: "Jobdetail",
        params: { id: this.$route.query.id.toString() },
      });
    }
  }
  mounted() {
    this.filterPanels = [
      {
        uid: 1,
        title: "Tätigkeitsbereiche",
        catalogType: "",
        options: {},
      },
      {
        uid: 2,
        title: "Standort",
        catalogType: "",
        options: {},
      },
      {
        uid: 3,
        title: "Einstiegslevel",
        catalogType: "AUDIENCE",
        options: {},
      },
      {
        uid: 4,
        title: "Zeitmodell",
        catalogType: "WORKING_HOURS",
        options: {},
      },
    ];
    const elm = document.querySelector<HTMLElement>(".k-header")!;
    if (elm) elm.style.display = "block";
    const elm2 = document.querySelectorAll<HTMLElement>(".k-c2a-banner")!;
    elm2.forEach((element) => {
      if (element) element.style.display = "block";
    });
    const elm3 = document.querySelector<HTMLElement>(".k-steps")!;
    if (elm3) elm3.style.display = "block";
    const elm4 = document.querySelector<HTMLElement>(".k-threecol-team")!;
    if (elm4) elm4.style.display = "block";
    this.buildFilters();
    this.getJobs(this.clientMain);
    this.getWorkingHours();
    this.getDataFromStorage();
  }
  @Watch("jobcategories")
  onCategoryChange() {
    const parsed = JSON.stringify(this.jobcategories);
    localStorage.setItem("jobcategories", parsed);
  }
  @Watch("audiences")
  onAudiencesChange() {
    const parsed = JSON.stringify(this.audiences);
    localStorage.setItem("audiences", parsed);
  }
  @Watch("worktimes")
  onWorktimesChange() {
    const parsed = JSON.stringify(this.worktimes);
    localStorage.setItem("worktimes", parsed);
  }
  @Watch("locations")
  onLocationsChange() {
    const parsed = JSON.stringify(this.locations);
    localStorage.setItem("locations", parsed);
  }
  @Watch("jobsFiltered")
  onFilteredJobsChange() {
    const parsed = JSON.stringify(this.jobsFiltered);
    localStorage.setItem("jobsFiltered", parsed);
  }

  async getDataFromStorage() {
    if (localStorage.getItem("jobcategories")) {
      this.jobcategories = JSON.parse(localStorage.getItem("jobcategories")!);
    }
    if (localStorage.getItem("audiences")) {
      this.audiences = JSON.parse(localStorage.getItem("audiences")!);
    }
    if (localStorage.getItem("worktimes")) {
      this.worktimes = JSON.parse(localStorage.getItem("worktimes")!);
    }
    if (localStorage.getItem("locations")) {
      this.locations = JSON.parse(localStorage.getItem("locations")!);
    }
    if (localStorage.getItem("jobsFiltered")) {
      this.jobsFiltered = JSON.parse(localStorage.getItem("jobsFiltered")!);
    } else {
      this.resetFilter();
      console.log("No jobs found in local storage, resetting filter");
    }
  }
  x(arr1: any[], arr2: string | any[]) {
    return arr1.filter((val) => arr2.includes(val));
  }
  async filterJobs() {
    this.loading = true;
    let jobsTemp: any[] = [];
    jobsTemp = this.jobs.filter(
      (job) =>
        (!this.locations.length ||
          this.locations.includes(job.geo_city) ||
          (job.additionalLocations &&
            job.additionalLocations.some((loc: any) =>
              this.locations.includes(loc.geo_city)
            ))) &&
        (!this.worktimes.length ||
          this.x(this.worktimes, job.workTimes[0]).length) &&
        (!this.audiences.length ||
          this.x(this.audiences, job.audiences[0]).length) &&
        (!this.jobcategories.length ||
          this.x(this.jobcategories, job.internal_reference_id).length)
    );
    this.jobsFiltered = jobsTemp;

    this.loading = false;
  }
  resetFilter() {
    this.jobsFiltered = this.jobs;
    this.jobcategories = [];
    this.audiences = [];
    this.worktimes = [];
    this.locations = [];
  }
  buildFilters() {
    this.filterPanels.forEach((filter) => {
      if (filter.catalogType) {
        let config = {
          method: "get",
          maxBodyLength: Infinity,
          url:
            "https://api.softgarden.io/api/rest/v3/frontend/catalogs/" +
            filter.catalogType +
            "?locale=DE",
          headers: {
            "Content-Type": "application/json",
          },
          auth: {
            username: this.clientMain,
            password: "",
          },
        };

        axios
          .request(config)
          .then((response) => {
            filter.options = response.data;
          })
          .catch((error) => {
            console.log(error);
          });
      }
    });
  }
  async getWorkingHours() {
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: "https://api.softgarden.io/api/rest/v3/frontend/catalogs/WORKING_HOURS?locale=DE",
      headers: {
        "Content-Type": "application/json",
      },
      auth: {
        username: this.clientMain,
        password: "",
      },
    };
    let workingLabel = "";
    axios
      .request(config)
      .then((response) => {
        this.workingTimes = response.data;
      })
      .catch((error) => {
        console.log(error);
      });
  }
  async getJobs(uid: any) {
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: "https://api.softgarden.io/api/rest/v3/frontend/jobslist/channels",
      headers: {
        "Content-Type": "application/json",
      },
      auth: {
        username: uid,
        password: "",
      },
    };
    axios
      .request(config)
      .then((response: { data: any }) => {
        response.data.forEach((channel: { id: any }) => {
          if (channel.id) {
            let config = {
              method: "get",
              maxBodyLength: Infinity,
              url:
                "https://api.softgarden.io/api/rest/v3/frontend/jobslist/" +
                channel.id,
              headers: {
                "Content-Type": "application/json",
              },
              auth: {
                username: uid,
                password: "",
              },
            };
            axios
              .request(config)
              .then((response: { data: any }) => {
                if (response.data.results.length > 0) {
                  response.data.results.forEach((job: any, index: number) => {
                    this.jobs.push(job);
                  });
                }
                this.jobs.forEach((job) => {
                  // add geo_city to filter options
                  if (job.geo_city) {
                    this.$set(
                      this.filterPanels[1].options,
                      job.geo_city,
                      job.geo_city
                    );
                  }

                  // add additional locations to filter options
                  if (job.additionalLocations) {
                    job.additionalLocations.forEach((location: any) => {
                      if (location.geo_city) {
                        this.$set(
                          this.filterPanels[1].options,
                          location.geo_city,
                          location.geo_city
                        );
                      }
                    });
                  }
                  if (job.internal_reference_id) {
                    this.$set(
                      this.filterPanels[0].options,
                      job.internal_reference_id,
                      job.internal_reference_id
                    );
                  }
                });

                // Group the jobs by audiences:
                // Senior Level
                // Mid Level
                // Junior Level
                // Teamassistenz
                // Trainees
                // Studierende
                // Praktikanten
                const customGroups = [
                  "b3942c34-cb9f-449d-8768-220cf326fecc",
                  "6cb34626-9d08-4f4f-8e7a-7720b74d3269",
                  "532d3c8f-f8a8-428c-99c2-0d1ed02a526f",
                  "a1e60bfb-6e23-4354-bccc-3aa16ebe8b65",
                  "7f85e9c6-62dc-443a-ab19-177a152f05b6",
                  "a514f6ef-e8a3-4f5d-bcfb-ecd6f16709b6",
                  "e075791f-bd77-4bf8-a38a-1937819030bc",
                ];
                // Sort filter panel 2 options object by customGroups order, preserving labels
                const sortedKeys = Object.keys(
                  this.filterPanels[2].options
                ).sort((a, b) => {
                  return customGroups.indexOf(a) - customGroups.indexOf(b);
                });
                const sortedOptions: Record<string, string> = {};
                sortedKeys.forEach((key) => {
                  sortedOptions[key] = this.filterPanels[2].options[key];
                });
                this.filterPanels[2].options = sortedOptions;
                const customGroupedJobs = customGroups.reduce(
                  (acc: Record<string, any[]>, group) => {
                    acc[group] = [];
                    return acc;
                  },
                  {} as Record<string, any[]>
                );
                this.jobs.forEach((job) => {
                  job.audiences.forEach((audience: any) => {
                    if (customGroupedJobs[audience]) {
                      customGroupedJobs[audience].push(job);
                    }
                  });
                });
                // Sort each custom group by geo_city/city alphabetically
                for (const group in customGroupedJobs) {
                  customGroupedJobs[group].sort((a: any, b: any) =>
                    a.geo_city.localeCompare(b.geo_city)
                  );
                }
                this.customGroupedJobs = customGroupedJobs;

                // Flatten the grouped jobs back into a single array
                this.jobs = Object.values(customGroupedJobs).flat();
                this.jobsFiltered = Object.values(customGroupedJobs).flat();
                console.log("Jobs after grouping by audiences:", this.jobs);
                this.jobs.forEach((job) => {
                  // push geo_city field to additonalLocations if it exists
                  if (job.geo_city) {
                    // Ensure additionalLocations is an array
                    if (!Array.isArray(job.additionalLocations)) {
                      job.additionalLocations = [];
                    }
                    // Avoid duplicates
                    if (
                      !job.additionalLocations.some(
                        (loc: any) => loc.geo_city === job.geo_city
                      )
                    ) {
                      job.additionalLocations.push({ geo_city: job.geo_city });
                    }
                  }
                  if (Array.isArray(job.additionalLocations)) {
                    job.additionalLocations.sort((a: any, b: any) =>
                      a.geo_city.localeCompare(b.geo_city)
                    );
                  }
                });

                const sortedLocationKeys = Object.keys(
                  this.filterPanels[1].options
                ).sort();
                const sortedLocationOptions: Record<string, string> = {};
                sortedLocationKeys.forEach((key) => {
                  sortedLocationOptions[key] =
                    this.filterPanels[1].options[key];
                });
                this.filterPanels[1].options = sortedLocationOptions;
              })
              .catch((error: any) => {
                console.log(error);
              });
          }
        });
      })
      .catch((error: any) => {
        console.log(error);
      });
  }
}

export default Home;
